// extracted by mini-css-extract-plugin
module.exports = {"Feature":"Feature_Feature__2e89S","No":"Feature_No__kieqz","title":"Feature_title__2HkqP"};